import HTTP from "@/_helpers/http";
import { CLIENTS_DOCUMENTS__API } from "@/_helpers/urls";
import { CLIENTS_DOCUMENTS__MUTATIONS } from "../mutation-types";
import { CLIENTS_DOCUMENTS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  documents: [],
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [CLIENTS_DOCUMENTS__MUTATIONS.CLIENTS_DOCUMENTS](state, data) {
    state.documents = data?.data?.documents
    state.pagination = data?.data?.pagination;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};
// Actions
const actions = {
  async [CLIENTS_DOCUMENTS__ACTIONS.CLIENTS_DOCUMENTS]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
      const {
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${CLIENTS_DOCUMENTS__API.CLIENTS_DOCUMENTS}${queryParams ? `?${queryParams}` : ''}`
      );


      commit(CLIENTS_DOCUMENTS__MUTATIONS.CLIENTS_DOCUMENTS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },
  async [CLIENTS_DOCUMENTS__ACTIONS.UPLOAD_DOCUMENTS](
    { commit, dispatch },
    data
  ) {
    try {
      const response = await HTTP().post(
        CLIENTS_DOCUMENTS__API.UPLOAD_DOCUMENTS,
        data
      );

      if (response.status === 200) {
        await dispatch(CLIENTS_DOCUMENTS__ACTIONS.CLIENTS_DOCUMENTS);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async [CLIENTS_DOCUMENTS__ACTIONS.VERIFYDOC]({ commit, dispatch }, data) {
    try {
      const response = await HTTP().post(
        CLIENTS_DOCUMENTS__API.VERIFYDOC,
        data
      );

      if (response.status === 200) {
        //await dispatch(CLIENTS_DOCUMENTS__ACTIONS.CLIENTS_DOCUMENTS)
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response.data.message);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
